import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import routerInterceptor from '@/router/routerInterceptor'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import auth from '../authConfig'
import i18n from '../plugins/i18n'
import api from '../api/Client'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userInfo: {},
    lang: 'zh',
    footPrintInfo: null,
  },
  getters: {
    userInfo: (state) => state.userInfo,
    lang: (state) => state.lang,
  },
  mutations: {
    handleLang(state, lang) {
      state.lang = lang
      localStorage.setItem('lang', lang)
      i18n.locale = lang
      // eslint-disable-next-line no-restricted-globals
      // location.reload()
    },
    updateUserInfo(state, userInfo) {
      state.userInfo = {
        ...state.userInfo,
        ...userInfo,
      }
      localStorage.setItem('userInfo', JSON.stringify(state.userInfo))
    },
    updateFootPrint(state, footPrintInfo) {
      state.footPrintInfo = footPrintInfo
      localStorage.setItem('footPrintInfo', JSON.stringify(footPrintInfo))
    },
    initLang(state) {
      state.lang = localStorage.getItem('lang') || i18n.locale
      i18n.locale = state.lang
    },
    initStore(state) {
      // 放在localStorage 在這邊init
      if (localStorage.getItem('userInfo')) {
        state.userInfo = JSON.parse(localStorage.getItem('userInfo'))
      }
      if (localStorage.getItem('footPrintInfo')) {
        state.footPrintInfo = JSON.parse(localStorage.getItem('footPrintInfo'))
      }
    },
    logout() {
      auth.signOut().then(() => {
      }).catch((error) => {
        console.error(error)
      }).finally(() => {
        localStorage.clear()
        router.push('/')
      })
    },
  },
  actions: {
    async initFootPrint({ commit }) {
      const fp = await FingerprintJS.load()
      const footPrintInfo = await fp.get()
      commit('updateFootPrint', footPrintInfo)
    },
    async trackerLog({ state, dispatch }, { event, message }) {
      if (!state.footPrintInfo) await dispatch('initFootPrint')
      const page = router && router.history && router.history.ready ? router.history.current.name : ''
      const data = {
        info: {
          page,
          deviceFingerPrint: state.footPrintInfo.visitorId,
          behavior: event,
        },
        projectCode: localStorage.getItem('projectCode') || '',
        qrCode: localStorage.getItem('qrcode') || '',
      }
      if (message) data.info.message = message
      if ('userAgent' in navigator) {
        data.info.deviceInfo = navigator.userAgent
      }
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition((postion) => {
          console.debug(postion)
          data.info.latitude = postion.coords.latitude
          data.info.longitude = postion.coords.longitude
        })
      }
      data.info = JSON.stringify(data.info)
      api.post('/v1/follow/tracking', data)
    },
  },
  modules: {
  },
  plugins: [
    routerInterceptor(),
  ],
})
